module.exports = __webpack_public_path__ + "static/img/6.510737f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/6.png
// module id = hmeV
// module chunks = 0